// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__3rsk2","spinner":"Loading_spinner__3l8Ax"};